import React from "react";
/* Skeleton — Phase B primitive. Loading placeholder.
   variant: text | block | circle  (default: block)
   width / height: CSS dimension strings */

export interface SkeletonProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: "text" | "block" | "circle";
  width?: number | string;
  height?: number | string;
}

export default function Skeleton({ variant = "block", width, height, className = "", ...rest }: SkeletonProps) {
  const style: React.CSSProperties = {};
  if (width != null) style.width = typeof width === "number" ? `${width}px` : width;
  if (height != null) style.height = typeof height === "number" ? `${height}px` : height;
  return (
    <span
      className={`v2-skeleton v2-skeleton--${variant} ${className}`.trim()}
      style={style}
      aria-busy="true"
      aria-hidden="true"
      {...rest}
    />
  );
}
